import * as details from './details/DetailsActions';
import * as addresses from './addresses/AddressesActions';

const actions = {
  ...details,
  ...addresses,
};

export default actions;
